import React from 'react';
import NotFoundPageTemplate from "../../../../libs/templates/pageTemplates/NotFoundPageTemplate";

const NotFoundPage = () => <NotFoundPageTemplate isMenuEnabled={false} />;

export default NotFoundPage;
